"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var field = {
  operators: [{
    value: '=',
    label: '='
  }, {
    value: '!=',
    label: '!='
  }],
  defaultOperator: '=',
  filter: function filter(value, q) {
    var operator = q.operator,
        qv = q.value;

    if (qv !== '') {
      var queryValue = !!qv;

      switch (operator) {
        case '=':
          return value === queryValue;

        case '!=':
          return value !== queryValue;

        default:
          return false;
      }
    } else {
      return true;
    }
  },
  sort: function sort(orientation, a, b) {
    return (a - b) * orientation;
  },
  render: function render(_ref, _onChange) {
    var _ref$value = _ref.value,
        value = _ref$value === void 0 ? '' : _ref$value;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Switch, {
      onChange: function onChange(e, value) {
        _onChange({
          value: value
        });
      },
      value: value
    }));
  }
};
var _default = field;
exports.default = _default;
module.exports = exports.default;